import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('KissUserDA', KissUserDA);

    KissUserDA.$inject = ['Restangular', 'CONF', 'UserBo', 'User'];

    /* @ngInject */
    function KissUserDA(Restangular, CONF, UserBo, User) {
        var baseUrl = CONF.apiBaseUrl + '/v1/users';

        var exports = {
            searchUsers: searchUsers,
            searchUsersAuto: searchUsersAuto,
            getUser: getUser,
            changeStatus: changeStatus,
            getBoUsers: getBoUsers,
            getUserByLogin: getUserByLogin,
            saveUserBo: saveUserBo,
            checkContactEmail: checkContactEmail,
            createImpersonatedUser: createImpersonatedUser,
        };

        return exports;

        ////////////////
        /**
         * Recherche d'utilisateurs
         *
         * @param {UsersFilter} usersFilter - critères de recherche des utilisateurs
         */
        function searchUsers(usersFilter) {
            return Restangular.oneUrl(baseUrl)
                .all('search')
                .post(usersFilter)
                .then(function (pageUsers) {
                    return {
                        totalItems: pageUsers.totalElements,
                        users: _.map(pageUsers.content, function (u) {
                            return new UserBo(u);
                        }),
                    };
                });
        }
        /**
         * Permet de vérifier si l'email est déja utilisée ou non
         * @param {*} email
         * @return L'utilisateur qui existe déja , sinon null
         */
        function checkContactEmail(email) {
            return Restangular.oneUrl(baseUrl)
                .all('check-contact-mail')
                .customGET('', { email: email })
                .then(function (user) {
                    return new User(user);
                });
        }

        function searchUsersAuto(searchValue) {
            return Restangular.oneUrl(baseUrl)
                .all('search-user')
                .post({ value: searchValue })
                .then(function (pageUsers) {
                    return _.map(pageUsers.content, function (u) {
                        return new UserBo(u);
                    });
                });
        }

        /**
         * Récupère un utilisateur selon sonb login
         *
         * @param {string} login - Identifiant de l'utilisateur
         */
        function getUser(login, sellerId) {
            if (sellerId) {
                return Restangular.one(baseUrl, login)
                    .one('sellers', sellerId)
                    .oneUrl('bo')
                    .get()
                    .then(function (user) {
                        return new UserBo(user);
                    });
            } else {
                return Restangular.oneUrl(baseUrl)
                    .one(login, 'bo')
                    .get()
                    .then(function (user) {
                        return new UserBo(user);
                    });
            }
        }

        /**
         * Change le status d'un utilisateur
         *
         * @param {'ACTIVE'|'INACTIVE'|'LOCKED'} status - le nouveau status
         * @param {string} login - le login de l'utilisateur pour lequel on souhaite changer le status
         *
         */
        function changeStatus(status, login) {
            return Restangular.one(baseUrl, login).all('change-status').post({ status: status });
        }

        /**
         * Recherche les utilisateurs du Back-office.
         */
        function getBoUsers() {
            return Restangular.one(baseUrl)
                .all('bo-users')
                .customGET()
                .then(function (users) {
                    return _.map(users, function (u) {
                        return new User(u);
                    });
                });
        }

        /**
         * Recherche un utilisateur via son identifiant.
         * @param userId Identifiant de l'utilisateur
         */
        function getUserByLogin(login) {
            return Restangular.one(baseUrl, login)
                .customGET()
                .then(function (user) {
                    return new User(user);
                });
        }

        /**
         * Sauvegarde un utilisateur Back-office.
         */
        function saveUserBo(user) {
            return Restangular.one(baseUrl)
                .all('save-user-bo')
                .post(user)
                .then(function (user) {
                    return new User(user);
                });
        }

        /**
         * creation d'un utilisateur temporaire.
         */
        function createImpersonatedUser(id) {
            return Restangular.one(baseUrl)
                .one('impersonated-user', id)
                .get()
                .then(function (user) {
                    return new User(user);
                });
        }
    }
})();
